import { Card, Text } from "@chakra-ui/react";

/**
 * Shown while a query is still resolving.
 *
 * Worth having as its own component because the alternative keeps being
 * written by accident: `(rows ?? []).length === 0` treats "not loaded yet" and
 * "there are none" as the same thing, so a page announces that it is empty and
 * then contradicts itself half a second later. A Convex query is `undefined`
 * until it resolves; that is the state this renders.
 */
export function LoadingCard({ label }: { label: string }) {
  return (
    <Card.Root borderWidth="1px" borderColor="border">
      <Card.Body p={6}>
        <Text fontSize="sm" color="fg.muted">{label}</Text>
      </Card.Body>
    </Card.Root>
  );
}
